module.exports = __webpack_public_path__ + "img/logo-1-942857.png";